import Toggle from "./Toggle.js"
import Utils from "./Utils.js"

export default class CaptionToggleButton extends Toggle {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-cc")
    this.state.altText = "MSG_CLOSED_CAPTIONING"
    this.state.toggled = this.player.captioning ? !this.player.captioning.hidden : false
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onmediachange() {
    setTimeout(this.forceUpdate.bind(this), 1)
  }

  onChange(event) {
    this.player.captioning.hidden = !this.player.captioning.hidden
  }

  render() {
    if (!Utils.componentEnabled(this.plugin, "captioning"))
      return null

    return super.render()
  }
}
